<template>
  <CockpitDialog class="detail-dialog left-520px top-200px" title="盲板详情" @close="close">
    <el-form
      :model="formData"
      ref="detailForm"
      class="form-wrap mt-15px"
      label-width="120px"
      v-loading="formLoading"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="盲板编码" prop="code">
            <el-input
              v-model="formData.code"
              size="small"
              placeholder="请填写编码"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="盲板形状" prop="shape">
            <el-input v-model="formData.shape" size="small" placeholder="" readonly></el-input>
          </el-form-item>
          <el-form-item label="关联PID图号" prop="pid">
            <el-input v-model="formData.pid" size="small" placeholder="" readonly></el-input>
          </el-form-item>
          <el-form-item label="材质" prop="materialQuality">
            <el-input
              v-model="formData.materialQuality"
              size="small"
              placeholder=""
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="盲板规格" prop="specifications">
            <el-input
              v-model="formData.specifications"
              size="small"
              placeholder=""
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="点位坐标" prop="positionObj">
            <div class="position-wrap flex">
              <el-input
                size="small"
                v-model="formData.positionObj.X"
                placeholder="请选择"
                readonly
              ></el-input>
              <el-input
                size="small"
                v-model="formData.positionObj.Y"
                placeholder="请选择"
                class="ml-5px"
                readonly
              ></el-input>
              <el-input
                size="small"
                v-model="formData.positionObj.Z"
                placeholder="请选择"
                class="ml-5px"
                readonly
              ></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="盲板安装类型" prop="type">
            <el-input v-model="formData.type" size="small" placeholder="" readonly></el-input>
          </el-form-item>
          <el-form-item label="盲板位置" prop="positionDescription">
            <el-input
              v-model="formData.positionDescription"
              size="small"
              placeholder="请填写位置"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="介质" prop="medium">
            <el-input v-model="formData.medium" size="small" placeholder="" readonly></el-input>
          </el-form-item>
          <el-form-item label="公称压力MPa" prop="pressureLevel">
            <el-input
              v-model="formData.pressureLevel"
              size="small"
              placeholder=""
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="盲板状态" prop="status">
            <el-input v-model="formData.status" size="small" placeholder="" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </CockpitDialog>
</template>

<script>
import { cloneDeep } from 'lodash'

const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}

export default {
  components: { CockpitDialog },
  props: {
    currentBlindPlate: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      formLoading: false,
      formData: {
        shape: null,
        pid: null,
        materialQuality: null,
        specifications: null,
        pressureLevel: null,
        type: null,
        medium: null,
        positionObj: {
          X: null,
          Y: null,
          Z: null,
        },
        code: null,
        positionDescription: null,
        status: null,
      },
    }
  },
  watch: {
    'currentBlindPlate.id': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getDetail()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {},
  created() {
    this.getDetail()
  },
  methods: {
    // 关闭阀门详情弹窗
    close() {
      this.$emit('closeGxDetail', 'currentBlindPlate')
    },
    // 填充详情信息
    getDetail() {
      this.formLoading = true
      let positionObj = {
        X: null,
        Y: null,
        Z: null,
      }
      if (this.currentBlindPlate.pointId) {
        const pos = JSON.parse(this.currentBlindPlate.position)
        positionObj = {
          X: pos[0],
          Y: pos[1],
          Z: pos[2],
        }
      }

      this.formData = { ...this.formData, ...this.currentBlindPlate, positionObj }
      this.formLoading = false
    },
  },
  beforeDestroy() {},
}
</script>
<style lang="scss" scoped>
.detail-dialog {
  ::v-deep .el-loading-mask {
    background: #1a4447ad !important;
  }
  ::v-deep .el-input .el-input__inner {
    height: 28px !important;
    line-height: 28px !important;
    width: 250px !important;
  }
  .position-wrap {
    ::v-deep .el-input {
      width: 80px !important;
      .el-input__inner {
        width: 100% !important;
        padding: 0 5px !important;
      }
    }
  }
}
</style>
